import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Collapse as ChakraCollapse, Link } from '@chakra-ui/react';
import { formatDataTestId, renderSanitizedHtml } from '@whitbread-eos/utils';
import React, { useEffect, useRef, useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Collapse = ChakraCollapse;
export default function CollapseExpandText(props) {
  var baseTestId = props.baseTestId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDescriptionExpanded = _useState2[0],
    setIsDescriptionExpanded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isExpandLinkClicked = _useState4[0],
    setIsExpandLinkClicked = _useState4[1];
  var _useState5 = useState(props.startingHeight),
    _useState6 = _slicedToArray(_useState5, 2),
    collapseHeight = _useState6[0],
    setCollapseHeight = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isTextHeightClamped = _useState8[0],
    setIsTextHeightClamped = _useState8[1];
  var collapseRef = useRef(null);
  var descriptionRef = useRef(null);
  var handleToggleExpand = () => {
    setIsExpandLinkClicked(true);
    setIsDescriptionExpanded(prev => !prev);
  };
  useEffect(() => {
    var descriptionEl = descriptionRef.current;
    var collapseEl = collapseRef.current;
    if (descriptionEl !== null && descriptionEl !== void 0 && descriptionEl.scrollHeight) {
      var nextHeight = descriptionEl.scrollHeight <= collapseHeight ? descriptionEl.scrollHeight : collapseHeight;
      if (nextHeight !== collapseHeight) setCollapseHeight(nextHeight);
    }
    if (collapseEl !== null && collapseEl !== void 0 && collapseEl.scrollHeight) {
      var shouldClamp = (descriptionEl === null || descriptionEl === void 0 ? void 0 : descriptionEl.scrollHeight) > collapseEl.scrollHeight || isExpandLinkClicked;
      if (shouldClamp !== isTextHeightClamped) setIsTextHeightClamped(shouldClamp);
    }
  }, [collapseHeight, isExpandLinkClicked, isTextHeightClamped, props.contentText]);
  return _jsxs(Box, _objectSpread(_objectSpread({}, descriptionWrapperStyle), {}, {
    "data-testid": formatDataTestId(baseTestId, 'Content'),
    children: [_jsx(Box, {
      ref: collapseRef,
      children: _jsx(Collapse, {
        startingHeight: collapseHeight,
        in: isDescriptionExpanded,
        children: _jsx(Box, _objectSpread(_objectSpread({}, descriptionStyle), {}, {
          "data-testid": formatDataTestId(baseTestId, 'Description'),
          ref: descriptionRef,
          style: _objectSpread({
            WebkitLineClamp: isDescriptionExpanded ? 'unset' : props.noOfLines,
            WebkitBoxOrient: 'vertical'
          }, descriptionInlineStyle),
          className: props.isHtml ? 'formatLinks' : '',
          children: props.isHtml ? renderSanitizedHtml(props.contentText) : props.contentText
        }))
      })
    }), props.isFadeEffect && _jsx(Box, {
      mt: "-5rem",
      height: "5rem",
      position: "relative",
      display: isTextHeightClamped && !isDescriptionExpanded ? 'block' : 'none',
      bg: "".concat(isTextHeightClamped && !isDescriptionExpanded && props.contentText.length > 200 && 'linear-gradient(to bottom, var(--chakra-colors-fadedBaseWhite) 0%, var(--chakra-colors-baseWhite) 75%)')
    }), _jsx(Link, _objectSpread(_objectSpread({
      as: "button",
      "data-testid": formatDataTestId(baseTestId, 'Expand-Collapse'),
      display: isTextHeightClamped ? 'block' : 'none'
    }, linkStyle), {}, {
      onClick: handleToggleExpand,
      children: isDescriptionExpanded ? props.collapseButtonText : props.expandButtonText
    }))]
  }));
}
var descriptionStyle = {
  fontSize: 'lg',
  fontWeight: 'normal'
};
var descriptionInlineStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box'
};
var linkStyle = {
  textDecoration: 'underline',
  color: 'tertiary',
  _focus: {
    outline: 'none'
  },
  fontSize: 'md',
  fontWeight: 'normal',
  marginTop: 'var(--chakra-space-xs)'
};
var descriptionWrapperStyle = {
  marginBottom: 'var(--chakra-space-lg)',
  marginTop: 'var(--chakra-space-lg)'
};